import React, { useEffect, useState } from 'react';
import GoTrue from 'gotrue-js';
import {
  Form,
  Button,
  Container,
  Row,
  Col,
  Jumbotron,
  Spinner,
} from 'react-bootstrap';
import Axios from 'axios';
import { SignUpModal } from '../Components/SignUpModal';
import { Link } from 'react-router-dom';
import { baseURL } from '../utils/constants';
import { AuthLogin, AuthSignup } from '../utils/NewAuthService';
export const AdminSignup = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');

  const [courseName, setCourseName] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [listAC, setLSAC] = useState([]);
  const [isLogged, setLogging] = useState(false);
  const [created, setCreated] = useState(false);
  const [field, setField] = useState([]);

  // ADMIN
  const [isAuthenticated,setAuthentication] = useState(false);
  const [adminEmail, setAdminEmail] = useState('');
  const [adminPassword, setAdminPassword] = useState('');

  const auth = new GoTrue({
    APIUrl: 'https://utech-studentportal.netlify.app/.netlify/identity',
    audience: '',
    setCookie: false,
  });
  function slugGen(str) {
    return (str.charAt(0).toLowerCase() + str.slice(1))
      .replace(/\s/g, '')
      .replace(/[^a-zA-Z0-9 ]/g, '');
  }

  const signUp = async (event) => {
    event.preventDefault();

    if (field.length > 0) {
      setLogging(true);

      AuthSignup(name,email,password,JSON.stringify(field.map((elem) => slugGen(elem))),JSON.stringify(field))
        .then((response) => {
          setCreated(true);
          console.log(response);
        })
        .catch((error) => {
          setErrorMessage(error.response.data.message);
          setLogging(false);
        });
    } else {
      alert('You have not selected any course');
    }
  };

  const getAvailableCourses = () => {
    Axios({
      url: 'https://graphql.contentful.com/content/v1/spaces/pmwy92zqo6ar/?access_token=nHEca_SIZp5oUECVGuJwQ57-xMDvg9PEzZ1BrEB_zg0',
      method: 'post',
      data: {
        query: `
        {
          pricingCollection {
            items {
              name
            }
          }
        }
          `,
      },
    })
      .then((res) => {
        let AC = res.data.data.pricingCollection.items;
        let newAC = AC.map(({ name }) => name);
        setLSAC(newAC);
      })
      .catch(console.error);
  };
  const handleCheckboxChange = (event) => {
    let newArray = [...field, event.currentTarget.value];
    if (field.includes(event.currentTarget.value)) {
      newArray = newArray.filter((elem) => elem !== event.currentTarget.value);
    }
    setField(newArray);
  };
  
  const _adminLogin = async (event)=>{
    event.preventDefault();
   try{
    const response = await AuthLogin(adminEmail,adminPassword);
    if(response.data.user.role === 'admin'){
      localStorage.setItem('tokens',JSON.stringify(response.data.tokens))  
      setAuthentication(true);
    }
   }
   catch(ex){
     console.log(ex)
     window.location.reload();
   }
  }
  
  useEffect(()=>{
    if(isAuthenticated){
      getAvailableCourses()
    }
  }, [isAuthenticated]);




  if(!isAuthenticated){
    return (<Container fluid className='bg-custom min-vh-100'>
            
             <Row className='justify-content-center p-5'>
             <Col md={6} className='my-auto'>
               <Jumbotron className='form-pannel align-middle'>
                 <h2>Utech SignUp Form</h2>
                 <p className='pt-2 text-center'>
                   Please Login From Admin User
                 </p>
                 <Form onSubmit={_adminLogin} className='form-custom'>
                   <Form.Row>
                     <Col md={6}>
                       <Form.Group controlId='formBasicEmail'>
                         <Form.Label>Email</Form.Label>
                         <Form.Control
                           required
                           onChange={(event) => setAdminEmail(event.target.value)}
                           type='email'
                           placeholder='Email Address'
                         />
                       </Form.Group>
                     </Col>
                     <Col>
                       <Form.Group controlId='formBasicPassword'>
                         <Form.Label>Password</Form.Label>
                         <Form.Control
                           required
                           onChange={(event) => setAdminPassword(event.target.value)}
                           type='password'
                           placeholder='Password'
                         />
                       </Form.Group>
                     </Col>
                   </Form.Row>
                   
                   <Form.Group>
                     <a className='forgetPassword'>Need Help ?</a>
                   </Form.Group>
                   <Button disabled={isLogged} variant='inherit' type='submit'>
                     {isLogged ? (
                       <Spinner size='sm' animation='border'></Spinner>
                     ) : (
                       'Login'
                     )}
                   </Button>
                   
                 </Form>
               </Jumbotron>
             </Col>
           </Row>
            </Container>)
  }

  return (
    <Container fluid className='bg-custom min-vh-100'>
      {created ? <SignUpModal email={email} password={password} /> : null}
      <Row className='justify-content-center p-5'>
        <Col md={6} className='my-auto'>
          <Jumbotron className='form-pannel align-middle'>
            <h2>Utech Account Creation</h2>
            <p className='pt-2 text-center'>
              Create Student Accounts
            </p>
            <Form onSubmit={signUp} className='form-custom'>
              <Form.Row>
                <Col md={6}>
                  <Form.Group controlId='formBasicEmail'>
                    <Form.Label>Student Email</Form.Label>
                    <Form.Control
                      required
                      onChange={(event) => setEmail(event.target.value)}
                      type='email'
                      placeholder='Email Address'
                    />
                  </Form.Group>
                </Col>
                <Col>
                  <Form.Group controlId='formBasicPassword'>
                    <Form.Label>Student Password</Form.Label>
                    <Form.Control
                      required
                      onChange={(event) => setPassword(event.target.value)}
                      type='text'
                      placeholder='Password'
                    />
                  </Form.Group>
                </Col>
              </Form.Row>
              <Form.Row>
                <Col>
                  <Form.Group controlId='formBasicName'>
                    <Form.Label>Student Name</Form.Label>
                    <Form.Control
                      required
                      onChange={(event) => setName(event.target.value)}
                      type='text'
                      name='name'
                    />
                  </Form.Group>
                </Col>
              </Form.Row>
              <Form.Row>
                <Form.Group controlId='formBasicCheckbox'>
                  <Form.Label>Available Courses</Form.Label>
                  {listAC.map((elem) => {
                    return (
                      <Form.Row key={elem}>
                        <Col>
                          <Form.Check
                            type='checkbox'
                            id={`formbasiccheckbox_${elem}`}
                            checked={field.includes(elem)}
                            onChange={handleCheckboxChange}
                            value={elem}
                            label={elem}
                          />
                        </Col>
                      </Form.Row>
                    );
                  })}
                </Form.Group>
              </Form.Row>
              <Form.Row>
                <Col>
                  <Form.Group controlId='formBasicName'>
                    <Form.Label>Student Identifiers</Form.Label>
                    <Form.Control
                      required
                      readOnly
                      value={field.map((elem) => slugGen(elem)).toString()}
                      type='text'
                      name='role'
                    />
                    <Form.Text style={{ fontSize: 14, color: 'red' }}>
                      When creating the course make sure to use the same
                      identefier.
                    </Form.Text>
                  </Form.Group>
                </Col>
              </Form.Row>
              <Form.Group>
                <a className='forgetPassword'>Need Help ?</a>
              </Form.Group>
              <Form.Group>
                <p className='text-danger'>{errorMessage}</p>
              </Form.Group>
              <Button disabled={isLogged} variant='inherit' type='submit'>
                {isLogged ? (
                  <Spinner size='sm' animation='border'></Spinner>
                ) : (
                  'Create Account'
                )}
              </Button>
              <Link to='/admin/update'>
              <div style={{color:'#d89d4b'}} className='font-weight-normal text-center mt-3'>
              Update Account
              </div>
              </Link>
            </Form>
          </Jumbotron>
        </Col>
      </Row>
    </Container>
  );
};
